/**
 * Split a single CSV line into cells, respecting RFC 4180 double-quote rules.
 *
 * - A cell may be wrapped in double quotes; delimiter inside quotes is literal.
 * - Inside a quoted cell, two consecutive double quotes (`""`) represent a single
 *   literal double quote.
 * - Empty cells are preserved (`a;;c` → `['a', '', 'c']`).
 *
 * @param line   A single CSV line (no embedded newlines unless caller has joined
 *               multi-line quoted cells beforehand).
 * @param delimiter Single-character delimiter (`;`, `,`, `\t`, `|`).
 */
export const splitCSVLine = (line: string, delimiter: string): string[] => {
  const cells: string[] = [];
  let cell = '';
  let inQuotes = false;
  let i = 0;

  while (i < line.length) {
    const ch = line[i];

    if (inQuotes) {
      if (ch === '"') {
        // Look ahead for an escaped double quote (`""`).
        if (line[i + 1] === '"') {
          cell += '"';
          i += 2;
          continue;
        }
        // Closing quote — exit quoted state.
        inQuotes = false;
        i += 1;
        continue;
      }
      cell += ch;
      i += 1;
      continue;
    }

    // Not inside quotes.
    if (ch === '"') {
      inQuotes = true;
      i += 1;
      continue;
    }
    if (ch === delimiter) {
      cells.push(cell);
      cell = '';
      i += 1;
      continue;
    }
    cell += ch;
    i += 1;
  }

  cells.push(cell);
  return cells;
};
